module.exports = __webpack_public_path__ + "static/media/Lock-Unlock-Aadhaar-Biometric-Data.24afd120.jpg";